import apiAnimals from "../config/api_animals";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

export function findAll(payload) {
  const { groupId, farmId } = payload;
  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/reproductive/protocols`,
    getHeaders(false, null)
  );
}

export function save(payload) {
  const { groupId, farmId, id, body } = payload;
  if (id === null) {
    return apiAnimals.post(
      `/bovexo/${groupId}/farms/${farmId}/reproductive/protocols`,
      body,
      getHeaders(false, null)
    );
  } else {
    return apiAnimals.patch(
      `/bovexo/${groupId}/farms/${farmId}/reproductive/protocols/${id}`,
      body,
      getHeaders(false, null)
    );
  }
}

export function saveForGroup(payload) {
  const { groupId, id, body } = payload;
  if (id === null) {
    return apiAnimals.post(
      `/bovexo/${groupId}/farms/reproductive/protocols`,
      body,
      getHeaders(false, null)
    );
  } else {
    return apiAnimals.patch(
      `/bovexo/${groupId}/farms/reproductive/protocols/${id}`,
      body,
      getHeaders(false, null)
    );
  }
}

export function inactivate(payload) {
  const { groupId, farmId, id } = payload;
  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/reproductive/protocols/${id}/inactivate`,
    null,
    getHeaders(false, null)
  );
}

export function activate(payload) {
  const { groupId, farmId, id } = payload;
  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/reproductive/protocols/${id}/activate`,
    null,
    getHeaders(false, null)
  );
}
